import { render, staticRenderFns } from "./extended-preference-field.vue?vue&type=template&id=1c09b5ec"
import script from "./extended-preference-field.vue?vue&type=script&lang=js"
export * from "./extended-preference-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports